module.exports = __webpack_public_path__ + "img/school_xjsdfz.bb7d5688.png";